import { defineStore } from 'pinia'
import { getShop, getDeliveryDates } from '@/api/api'
import { useShopsStore } from '@/stores/Shops.store'

export const useCopyOrderStore = defineStore('copyOrder', {
  state: () => ({
    orderDetails: {
      instruction: '',
      pickUpAddress: {},
      deliveryAddress: {},
      invoiceAddress: {},
      deliveryDate: {},
      pickUpDate: {},
      quotationNo: '',
      project: {
        id: 0,
        name: ''
      },
      reference: '',
      externalId: '',
      orderType: 'copyOrder'
    },
    shop: {},
    deliveryDates: [],
    pickUpDates: [],
    orderErrors: []
  }),
  actions: {
    resetOrder() {
      this.orderDetails = {
        instruction: '',
        pickUpAddress: {},
        deliveryAddress: {},
        invoiceAddress: {},
        deliveryDate: {},
        pickUpDate: {},
        quotationNo: '',
        project: {
          id: 0,
          name: ''
        },
        reference: '',
        externalId: '',
        orderType: 'copyOrder'
      }
      this.shop = {}
      this.deliveryDates = []
      this.pickUpDates = []
      this.orderErrors = []
    },
    addOrderError(error) {
      if (!this.orderErrors.includes(error)) {
        this.orderErrors.push(error)
      }
    },
    removeOrderError(error) {
      this.orderErrors = this.orderErrors.filter((e) => e !== error)
    },
    updateProject(proj) {
      this.orderDetails.project.name = proj.name || ''
      this.orderDetails.project.id = proj.id || 0
    },
    updateOrderDetails(spec, value) {
      this.orderDetails[spec] = value
    },
    updateShop(shop) {
      this.shop = shop
    },
    updatePickUpDates(dates) {
      this.pickUpDates = dates
    },
    updateDeliveryDates(dates) {
      this.deliveryDates = dates
    },
    getThePickUpDates(val) {
      return getDeliveryDates(val.shopId, val.invoiceId, val.secure).then(
        (resp) => {
          this.updatePickUpDates(resp)
          return resp
        }
      )
    },
    getTheDeliveryDates(val) {
      return getDeliveryDates(
        val.shopId,
        val.invoiceId,
        val.secure,
        val.offset
      ).then((resp) => {
        this.updateDeliveryDates(resp)
        return resp
      })
    },
    getTheShop(val) {
      const shopsStore = useShopsStore()
      return getShop(val.deliveryAddress, val.invoiceId, val.secure).then(
        (resp) => {
          const shop =
            shopsStore.shopsList.find((shop) => resp.location.id === shop.id) ||
            {}
          this.updateShop(shop)
        }
      )
    }
  }
})
